const createIntent = (reader) => {
  if (reader === 'wpe') {
    return '- (void)createPaymentIntent:(void (^)(NSString *__nullable, NSError *__nullable))completion;';
  }
};

export default ({reader}) => {
  return `#import <Foundation/Foundation.h>
#import <StripeTerminal/StripeTerminal.h>

NS_ASSUME_NONNULL_BEGIN

@interface APIClient : NSObject<SCPConnectionTokenProvider>

// For simplicity, this example class is a singleton
+ (instancetype)shared;

- (void)capturePaymentIntent:(NSString *)paymentIntentId
                  completion:(SCPErrorCompletionBlock)completion;
${createIntent(reader)}
@end

NS_ASSUME_NONNULL_END`;
};
